import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import { SiteLastUpdatedHead } from "./components/SiteLastUpdatedHead";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import { GoogleAnalytics } from "./components/GoogleAnalytics";
import SkipLink from "./components/SkipLink";
import { AuthProvider } from "./contexts/AuthContext";

const queryClient = new QueryClient();

const Layout = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <AuthProvider>
        <SiteLastUpdatedHead />
        <SkipLink />
        <ScrollToTop />
        <Navigation />
        <main id="main-content" tabIndex={-1} className="pt-16">
          <Outlet />
        </main>
        <Footer />
        <CookieConsent />
        <GoogleAnalytics />
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default Layout;
